import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
// import { DialogComponent } from '../component/dialog/dialog.component';
import { EditQuoteModalComponent } from '../component/edit-quote-modal/edit-quote-modal.component';
import { EditPropsoalModalComponent } from '../component/edit-propsoal-modal/edit-propsoal-modal.component';
import { PremiumBreakupComponent } from '../component/premium-breakup/premium-breakup.component';
import { QuotePremiumBreakupComponent } from '../component/quote-premium-breakup/quote-premium-breakup.component';
import { ErrorHandlerComponent } from '../component/error-handler/error-handler.component';
import { OTPComponent } from '../component/otp/otp.component';
import { AnnualIncomeModalComponent } from '../component/annual-income-modal/annual-income-modal.component';
import { ContactNumberComponent } from '../component/contact-number/contact-number.component';
import { DialogData } from '../model/data.model';
import { BQPOtpComponent } from '../component/bqp-otp/bqp-otp.component';
import { Overlay } from '@angular/cdk/overlay';
import { BiModalComponent } from '../component/bi-modal/bi-modal.component';
import { ComparisonModalComponent } from '../component/comparison-modal/comparison-modal.component';

// import {productConfig} from '../life-config/productCodeConfig.json';

@Injectable({
    providedIn: 'root'
})
export class CommonModalService {

    dialogConfig = new MatDialogConfig();
    constructor(
        public dialog: MatDialog,
        private overlay: Overlay) {
        this.dialogConfig.height = '50%';
        this.dialogConfig.width = '50%';
        // Over-riding default data value for modal window - if required
        this.dialogConfig.maxWidth = '100vw';
        this.dialogConfig.maxHeight = '100vh';
        this.dialogConfig.position = {
            top: '5%',
        };
    }

    openDialog(obj: DialogData): Observable<any> {


        let childComponent = null;
        const { width, height, minWidth, classNameObtained, dataInfo} = obj;
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        this.dialogConfig.maxWidth = '90vw';
        this.dialogConfig.data = dataInfo;
        this.dialogConfig.scrollStrategy = this.overlay.scrollStrategies.reposition();

        if (width) {
            this.dialogConfig.width = width;
        }
        if (height) {
            this.dialogConfig.height = height;
        }

        if (minWidth) {
            this.dialogConfig.minWidth = minWidth;

        }

        if (classNameObtained) {
            this.dialogConfig.panelClass = classNameObtained;
        }


        if (this.dialogConfig.data['top']) {
            this.dialogConfig.position = {
                top: this.dialogConfig.data['top']
            };
        }
        if (this.dialogConfig.data['left']) {
            this.dialogConfig.position['left'] = this.dialogConfig.data['left'];
        }
        if (obj.type === 1) {

            childComponent = EditQuoteModalComponent;
        }

        if (obj.type === 2) {

            childComponent = EditPropsoalModalComponent;
        }

        if (obj.type === 3) {

            childComponent = PremiumBreakupComponent;
        }

        if (obj.type === 4) {

            childComponent = QuotePremiumBreakupComponent;
        }
        if (obj.type === 5) {

            childComponent = ErrorHandlerComponent;
        }
        if (obj.type === 6) {
            childComponent = OTPComponent;
        }

        if (obj.type === 9) {

            childComponent = AnnualIncomeModalComponent;
        }
        if (obj.type === 10) {

            childComponent = ContactNumberComponent;
        }

        if (obj.type === 11) {

            childComponent = BQPOtpComponent;
        }

        if(obj.type === 12) {

            childComponent = BiModalComponent;
        }

        if(obj.type === 13) {

            childComponent = ComparisonModalComponent;
        }

        if (childComponent === null) {

            return null;
        }

        const dialogRef = this.dialog.open(childComponent, {
            data: this.dialogConfig.data,
            position: this.dialogConfig.position,
            width: this.dialogConfig.width,
            height: this.dialogConfig.height,
            minWidth: this.dialogConfig.minWidth,
            panelClass: this.dialogConfig.panelClass,
            scrollStrategy,
        });
        return dialogRef.afterClosed();





    }

}
